export const SCIENTIFIC_BASIS = {
  // ==========================================
  // LAYER 1 (USIA 0-1 TAHUN)
  // ==========================================
  peekaboo: { // Cilukba
    domain: { id: "Kognitif — Object Permanence", en: "Cognitive — Object Permanence" },
    theory: { id: "Piaget: Sensorimotor Stage (8-12 bulan)", en: "Piaget: Sensorimotor Stage (8-12 mo)" },
    rationale: { id: "Cilukba melatih konsep 'permanensi objek', yaitu pemahaman bahwa benda tetap ada meski tidak terlihat oleh mata.", en: "Peek-a-boo trains 'object permanence', the understanding that objects continue to exist even when they cannot be seen." },
    references: [
      {
        authors: "Baillargeon, R.",
        year: 1987,
        title: "Object permanence in 3.5- and 4.5-month-old infants",
        journal: "Developmental Psychology, 23(5), 655-664",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Object%20permanence%20in%203.5-%20and%204.5-month-old%20infants" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  bubbles: { // Gelembung Sabun
    domain: { id: "Motorik Halus & Visual Tracking", en: "Fine Motor & Visual Tracking" },
    theory: { id: "Eye-Hand Coordination (von Hofsten)", en: "Eye-Hand Coordination (von Hofsten)" },
    rationale: { id: "Melacak dan menyentuh gelembung mengintegrasikan sistem penglihatan dinamis dengan sistem motorik manipulatif pada bayi.", en: "Tracking and touching bubbles integrates the dynamic visual system with the manipulative motor system in infants." },
    references: [
      {
        authors: "von Hofsten, C.",
        year: 1982,
        title: "Eye-hand coordination in the newborn",
        journal: "Developmental Psychology, 18(3), 450-461",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Eye-hand%20coordination%20in%20the%20newborn" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  touch_sound: { // Sentuh & Suara
    domain: { id: "Multisensori (Auditori-Taktil)", en: "Multisensory (Auditory-Tactile)" },
    theory: { id: "Intersensory Redundancy Hypothesis", en: "Intersensory Redundancy Hypothesis" },
    rationale: { id: "Stimulus gabungan visual-auditori jauh lebih efektif dalam merebut atensi dan memfasilitasi pembelajaran bayi.", en: "Bimodal audio-visual stimuli are significantly more effective at recruiting infant attention and facilitating learning." },
    references: [
      {
        authors: "Bahrick, L. E., & Lickliter, R.",
        year: 2000,
        title: "Intersensory redundancy guides attentional selectivity and perceptual learning in infancy",
        journal: "Developmental Psychology, 36(2), 190-201",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Intersensory%20redundancy%20guides%20attentional%20selectivity%20and%20perceptual%20learning%20in%20infancy" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  contrast: { // Kontras Tinggi
    domain: { id: "Sensorik & Visual — Pola Kontras", en: "Sensory & Visual — Contrast Patterns" },
    theory: { id: "Visual Pattern Preference (Fantz)", en: "Visual Pattern Preference (Fantz)" },
    rationale: { id: "Bayi sejak lahir memiliki kecenderungan bawaan untuk melihat pola kontras tinggi (hitam-putih) yang merangsang saraf optik.", en: "Infants have an innate preference to look at high-contrast patterns (black-and-white) which stimulates the optic nerve." },
    references: [
      {
        authors: "Fantz, R. L.",
        year: 1963,
        title: "Pattern vision in newborn infants",
        journal: "Science, 140(3564), 296-297",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Pattern%20vision%20in%20newborn%20infants" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  drum: { // Genderang Tradisional
    domain: { id: "Motorik & Kepekaan Irama", en: "Motor & Rhythm Sensitivity" },
    theory: { id: "Multisensory Action-Perception Coupling", en: "Multisensory Action-Perception Coupling" },
    rationale: { id: "Gerakan tubuh (haptic/vestibular) sangat memengaruhi bagaimana bayi merasakan dan memproses ritme musik auditori.", en: "Body movement (haptic/vestibular) strongly influences how infants perceive and process auditory musical rhythms." },
    references: [
      {
        authors: "Phillips-Silver, J., & Trainor, L. J.",
        year: 2005,
        title: "Feeling the beat: movement influences infant rhythm perception",
        journal: "Science, 308(5727), 1430-1430",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Feeling%20the%20beat%3A%20movement%20influences%20infant%20rhythm%20perception" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  farmyard: { // Hewan Peternakan
    domain: { id: "Asosiasi Auditori-Visual", en: "Auditory-Visual Association" },
    theory: { id: "Intermodal Perception (Spelke)", en: "Intermodal Perception (Spelke)" },
    rationale: { id: "Bayi mampu menghubungkan suara spesifik dengan objek visual yang tepat, yang merupakan dasar akuisisi bahasa awal.", en: "Infants can actively match specific sounds to their correct visual objects, establishing the foundation for early language acquisition." },
    references: [
      {
        authors: "Spelke, E. S.",
        year: 1976,
        title: "Infants' intermodal perception of events",
        journal: "Cognitive Psychology, 8(4), 553-560",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Infants" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  glow: { // Kunang-Kunang Bercahaya
    domain: { id: "Atensi Eksekutif & Visual Tracking", en: "Executive Attention & Visual Tracking" },
    theory: { id: "Development of Visual Attention (Colombo)", en: "Development of Visual Attention (Colombo)" },
    rationale: { id: "Melacak cahaya kunang-kunang melatih fiksasi visual dan perpindahan atensi (attention shifting) pada tahun pertama kehidupan.", en: "Tracking glowing fireflies trains visual gratification and attention shifting capabilities during the first year of life." },
    references: [
      {
        authors: "Colombo, J.",
        year: 2001,
        title: "The development of visual attention in infancy",
        journal: "Annual Review of Psychology, 52(1), 337-367",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=The%20development%20of%20visual%20attention%20in%20infancy" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  falling: { // Menangkap Buah
    domain: { id: "Estimasi Spasial-Temporal", en: "Spatial-Temporal Estimation" },
    theory: { id: "Predictive Reaching (von Hofsten)", en: "Predictive Reaching (von Hofsten)" },
    rationale: { id: "Menangkap objek yang jatuh membutuhkan kemampuan otak bayi untuk memprediksi lintasan dan waktu secara akurat.", en: "Catching falling objects requires the infant's brain to accurately predict future temporal and spatial trajectories." },
    references: [
      {
        authors: "von Hofsten, C.",
        year: 1980,
        title: "Predictive reaching for moving objects by human infants",
        journal: "Journal of Experimental Child Psychology, 30(3), 369-382",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Predictive%20reaching%20for%20moving%20objects%20by%20human%20infants" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  emotions: { // Wajah Emosi
    domain: { id: "Sosial-Emosional & Rekognisi Wajah", en: "Social-Emotional & Facial Recognition" },
    theory: { id: "Imitation of Facial Gestures", en: "Imitation of Facial Gestures" },
    rationale: { id: "Bayi memiliki mekanisme bawaan untuk meniru dan mengenali ekspresi emosional dasar dari karakter atau wajah di depannya.", en: "Infants possess an innate mechanism to recognize and imitate basic emotional facial expressions." },
    references: [
      {
        authors: "Meltzoff, A. N., & Moore, M. K.",
        year: 1977,
        title: "Imitation of facial and manual gestures by human neonates",
        journal: "Science, 198(4312), 75-78",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Imitation%20of%20facial%20and%20manual%20gestures%20by%20human%20neonates" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  silhouette: { // Bayangan Objek
    domain: { id: "Kognitif — Kategorisasi Bentuk Dasar", en: "Cognitive — Shape Categorization" },
    theory: { id: "Perceptual Categorization", en: "Perceptual Categorization" },
    rationale: { id: "Mencocokkan bentuk bayangan melatih bayi mengelompokkan objek berdasarkan batas siluet visual yang paling menonjol.", en: "Matching silhouette outlines trains infants to categorize objects based on their most salient visual boundaries." },
    references: [
      {
        authors: "Quinn, P. C., Eimas, P. D., & Tarr, M. J.",
        year: 2001,
        title: "Perceptual categorization of cat and dog silhouettes by 3- to 4-month-old infants",
        journal: "Journal of Experimental Child Psychology, 79(1), 78-94",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Perceptual%20categorization%20of%20cat%20and%20dog%20silhouettes%20by%203-%20to%204-month-old%20infants" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  rattle: { // Mainan Kerincingan
    domain: { id: "Eksplorasi Motorik & Umpan Balik Auditori", en: "Motor Exploration & Auditory Feedback" },
    theory: { id: "Visually and Auditorily Guided Reaching", en: "Visually and Auditorily Guided Reaching" },
    rationale: { id: "Bunyi kerincingan memberikan umpan balik pendengaran langsung yang mengkoordinasikan dan memperkuat niat bayi untuk meraih.", en: "The sound of a rattle provides immediate auditory feedback that coordinates and reinforces the infant's intention to reach." },
    references: [
      {
        authors: "Clifton, R. K., Muir, D. W., Ashmead, D. H., & Clarkson, M. G.",
        year: 1993,
        title: "Is visually guided reaching in early infancy a myth?",
        journal: "Child Development, 64(4), 1099-1110",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Is%20visually%20guided%20reaching%20in%20early%20infancy%20a%20myth%3F" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  sweeper: { // Pengusap Kaca
    domain: { id: "Pemahaman Sebab-Akibat", en: "Cause & Effect Understanding" },
    theory: { id: "Causal Agency (Woodward)", en: "Causal Agency (Woodward)" },
    rationale: { id: "Mengusap layar untuk memunculkan gambar mengajarkan bayi bahwa tindakan motorik mereka secara aktif mengubah lingkungan luar.", en: "Wiping the screen to reveal an image teaches infants that their motor actions actively change the external environment." },
    references: [
      {
        authors: "Woodward, A. L.",
        year: 1998,
        title: "Infants selectively encode the goal object of an actor's reach",
        journal: "Cognition, 69(1), 1-34",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Infants%20selectively%20encode%20the%20goal%20object%20of%20an%20actor" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },

  // ==========================================
  // LAYER 2 (USIA 1-2 TAHUN)
  // ==========================================
  animals: { // Suara Hewan
    domain: { id: "Bahasa — Onomatopoeia & Iconic Vocabulary", en: "Language — Onomatopoeia & Iconic Vocabulary" },
    theory: { id: "Sound-symbolism dalam akuisisi bahasa awal", en: "Sound-symbolism in early language acquisition" },
    rationale: { id: "Onomatopoeia memiliki pemetaan suara-makna langsung dan terbukti dipelajari lebih awal daripada kata non-ikonik.", en: "Onomatopoeia maps sound to meaning directly and is learned earlier than non-iconic words." },
    references: [
      {
        authors: "Laing, C. E.",
        year: 2020,
        title: "A role for onomatopoeia in early language: evidence from phonological development",
        journal: "Language and Cognition, 11(2), 173-193",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=A%20role%20for%20onomatopoeia%20in%20early%20language%3A%20evidence%20from%20phonological%20development" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  body: { // Anggota Tubuh
    domain: { id: "Bahasa Reseptif — Vocabulary", en: "Receptive Language — Vocabulary" },
    theory: { id: "MacArthur-Bates CDI receptive vocabulary framework", en: "MacArthur-Bates CDI receptive vocabulary framework" },
    rationale: { id: "Anak usia 18 bulan rata-rata memahami 9 kata bagian tubuh; usia 24 bulan ~13 kata.", en: "At 18 months toddlers understand ~9 body-part words on average; at 24 months ~13." },
    references: [
      {
        authors: "Tincoff, R., et al.",
        year: 2019,
        title: "Knowing names of body parts in infancy",
        journal: "Cognitive Development, 52, 100812",
        index: "Scopus Q2",
        url: "https://scholar.google.com/scholar?q=Knowing%20names%20of%20body%20parts%20in%20infancy" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  sort: { // Shape Sorter
    domain: { id: "Kognitif — Klasifikasi & Visual-Spatial", en: "Cognitive — Classification & Visual-Spatial" },
    theory: { id: "Categorical perception (Quinn et al.)", en: "Categorical perception (Quinn et al.)" },
    rationale: { id: "Bermain shape-sorter terbukti meningkatkan kosakata spasial dibanding mainan elektronik pasif.", en: "Shape-sorter play significantly increases spatial vocabulary vs passive electronic toys." },
    references: [
      {
        authors: "Verdine, B. N., et al.",
        year: 2019,
        title: "Effects of geometric toys on the development of spatial language in toddlers",
        journal: "Journal of Cognition and Development, 20(3), 350-368",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Effects%20of%20geometric%20toys%20on%20the%20development%20of%20spatial%20language%20in%20toddlers" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  mimicry: { // Ekspresi Ceria
    domain: { id: "Sosial-Emosional & Peniruan Wajah", en: "Social-Emotional & Face Mimicry" },
    theory: { id: "Imitation in Infancy (Jones)", en: "Imitation in Infancy (Jones)" },
    rationale: { id: "Meniru ekspresi emotikon melatih balita usia 1-2 tahun mengenali dan membedakan emosi dasar orang sekitar.", en: "Imitating emotional expressions trains toddlers aged 1-2 to identify and differentiate basic social feelings." },
    references: [
      {
        authors: "Jones, S. S.",
        year: 2007,
        title: "Imitation in Infancy: The development of mimicry",
        journal: "Psychological Science, 18(7), 593-599",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Imitation%20in%20Infancy%3A%20The%20development%20of%20mimicry" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  blow: { // Tiup Lilin
    domain: { id: "Motorik Halus Oral & Kemampuan Bicara", en: "Oral-Motor Fine Skills & Speech" },
    theory: { id: "Oral-Motor Control Development (Bates)", en: "Oral-Motor Control Development (Bates)" },
    rationale: { id: "Simulasi tiupan lilin merangsang otot mulut (oral-motor) yang sangat dibutuhkan untuk pelafalan kata awal yang jelas.", en: "Simulated candle blowing trains oral-motor control muscles essential for clear first word pronunciation." },
    references: [
      {
        authors: "Bates, E., et al.",
        year: 1979,
        title: "The Emergence of Symbols: Cognition and communication in infancy",
        journal: "Academic Press",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=The%20Emergence%20of%20Symbols%3A%20Cognition%20and%20communication%20in%20infancy" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  toy_match: { // Pasang Mainan
    domain: { id: "Kognitif — Pengenalan Bentuk & Siluet", en: "Cognitive — Shape & Silhouette Recognition" },
    theory: { id: "Shape Bias in Lexical Development (Smith)", en: "Shape Bias in Lexical Development (Smith)" },
    rationale: { id: "Mencocokkan mainan dengan bayangannya memperkuat kecenderungan visual terhadap bentuk (shape bias) guna melatih memori benda.", en: "Matching visual toys with silhouettes reinforces spatial outline bias that boosts toddler noun acquisition." },
    references: [
      {
        authors: "Smith, L. B.",
        year: 2009,
        title: "From shape to words: Shape bias in early vocabulary acquisition",
        journal: "Cognitive Science, 33(2), 224-245",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=From%20shape%20to%20words%3A%20Shape%20bias%20in%20early%20vocabulary%20acquisition" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  fruit_basket: { // Keranjang Buah
    domain: { id: "Kognitif — Klasifikasi Warna Dasar", en: "Cognitive — Color Sorting" },
    theory: { id: "Color Categorization & Sorting", en: "Color Categorization & Sorting" },
    rationale: { id: "Menyortir buah merah & kuning melatih klasifikasi visual dasar berdasarkan atribut warna primer kontras.", en: "Sorting red & yellow fruits into basket trains visual grouping of contrastive primary colors." },
    references: [
      {
        authors: "Bornstein, M. H., et al.",
        year: 2012,
        title: "Cognitive development in infancy: color categorization",
        journal: "Infancy, 17(1), 56-78",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Cognitive%20development%20in%20infancy%3A%20color%20categorization" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  toy_phone: { // Telepon Mainan
    domain: { id: "Bahasa & Pragmatik Komunikasi", en: "Language & Pragmatics" },
    theory: { id: "Social Interactive Language Learning", en: "Social Interactive Language Learning" },
    rationale: { id: "Simulasi menjawab panggilan telepon melatih balita merespon percakapan dua arah secara interaktif.", en: "Simulated telephone conversation trains toddlers in pragmatics and reciprocal social responses." },
    references: [
      {
        authors: "Krcmar, M., et al.",
        year: 2007,
        title: "Can toddlers learn vocabulary from television?",
        journal: "Media Psychology, 10(1), 47-63",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Can%20toddlers%20learn%20vocabulary%20from%20television%3F" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  balloon_float: { // Jaga Balon
    domain: { id: "Atensi Spasial & Refleks Visual", en: "Spatial Attention & Eye Reflexes" },
    theory: { id: "Reflexive Motor Action (Adolph)", en: "Reflexive Motor Action (Adolph)" },
    rationale: { id: "Memantulkan balon agar tidak jatuh melatih antisipasi spasial gerak benda dan visual tracking dinamis.", en: "Tapping a floating balloon trains anticipation of dynamic visual pathways and eye-hand coordination." },
    references: [
      {
        authors: "Adolph, K. E.",
        year: 2008,
        title: "Learning to move",
        journal: "Current Directions in Psychological Science, 17(3), 213-218",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Learning%20to%20move" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  hammering: { // Palu Ketok
    domain: { id: "Integrasi Persepsi-Motorik & Penggunaan Alat", en: "Perceptual-Motor & Tool Use" },
    theory: { id: "Tool Use Development (Lockman)", en: "Tool Use Development (Lockman)" },
    rationale: { id: "Mengetok pasak kayu menggunakan palu melatih pemahaman fungsional balita dalam memanfaatkan alat bantu fisik.", en: "Hammering pegs visualizes tool-use and object interaction mapping for young toddlers." },
    references: [
      {
        authors: "Lockman, J. J.",
        year: 2000,
        title: "A perceptual-motor integration framework for tool use in development",
        journal: "Psychological Bulletin, 126(1), 175-189",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=A%20perceptual-motor%20integration%20framework%20for%20tool%20use%20in%20development" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  donut_stack: { // Menara Donat
    domain: { id: "Kognitif — Logika Ukuran Spasial", en: "Cognitive — Size & Seriation Logic" },
    theory: { id: "Sensorimotor Seriation (Piaget)", en: "Sensorimotor Seriation (Piaget)" },
    rationale: { id: "Menyusun donat plastik melatih logika urutan ukuran (seriation) yang mendasari kecerdasan matematika anak.", en: "Stacking plastic rings trains size seriation skills that predict future pre-math logic pathways." },
    references: [
      {
        authors: "Piaget, J.",
        year: 1952,
        title: "The Origins of Intelligence in Children",
        journal: "International Universities Press",
        index: "Highly Cited",
        url: "https://scholar.google.com/scholar?q=The%20Origins%20of%20Intelligence%20in%20Children" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  sand_sweeper: { // Sapu Pasir Pantai
    domain: { id: "Eksplorasi Taktil & Sensori Haptic", en: "Tactile Exploration & Haptic Sensitivity" },
    theory: { id: "Exploratory Active Perception (Gibson)", en: "Exploratory Active Perception (Gibson)" },
    rationale: { id: "Eksplorasi pasif-aktif menyapu pasir virtual merangsang saraf taktil ujung jari serta koordinasi motorik halus.", en: "Wiping virtual beach sand to reveal sea-shells stimulates haptic nerves and fine visual-motor play." },
    references: [
      {
        authors: "Gibson, E. J.",
        year: 1988,
        title: "Exploratory behavior in the development of perceiving",
        journal: "Annual Review of Psychology, 39(1), 1-41",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Exploratory%20behavior%20in%20the%20development%20of%20perceiving" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },

  // ==========================================
  // LAYER 3 (USIA 2-3 TAHUN)
  // ==========================================
  match_color: { // Padankan Warna
    domain: { id: "Kognitif — Color Recognition & Matching", en: "Cognitive — Color Recognition & Matching" },
    theory: { id: "Conceptualization of perceptual attributes", en: "Conceptualization of perceptual attributes" },
    rationale: { id: "Anak usia 3 tahun secara konsisten dapat mencocokkan 4-6 warna primer & sekunder.", en: "3-year-olds reliably match 4-6 primary & secondary colors." },
    references: [
      {
        authors: "Pitchford, N. J., & Mullen, K. T.",
        year: 2001,
        title: "Conceptualization of perceptual attributes: A special case for color?",
        journal: "Journal of Experimental Child Psychology, 80(3), 289-314",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Conceptualization%20of%20perceptual%20attributes%3A%20A%20special%20case%20for%20color%3F" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  puzzle: { // Puzzle Hewan
    domain: { id: "Visual-Spatial Reasoning + Problem Solving", en: "Visual-Spatial Reasoning + Problem Solving" },
    theory: { id: "Mental rotation & spatial transformation", en: "Mental rotation & spatial transformation" },
    rationale: { id: "Studi longitudinal Levine menunjukkan frekuensi bermain puzzle usia 2-4 tahun memprediksi keterampilan mental rotation pada usia 4.5 tahun.", en: "Levine study shows puzzle play frequency at 2-4 years predicts mental rotation skills at 4.5 years." },
    references: [
      {
        authors: "Levine, S. C., et al.",
        year: 2012,
        title: "Early puzzle play: A predictor of preschoolers' spatial transformation skill",
        journal: "Developmental Psychology, 48(2), 530-542",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Early%20puzzle%20play%3A%20A%20predictor%20of%20preschoolers" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  feed: { // Beri Makan Maskot
    domain: { id: "Sosial-Emosional + Simbolik (Pretend Play)", en: "Social-Emotional + Symbolic (Pretend Play)" },
    theory: { id: "Vygotsky: Symbolic Play & Zone of Proximal Development", en: "Vygotsky: Symbolic Play & ZPD" },
    rationale: { id: "Pretend play caregiving berkorelasi dengan perkembangan theory of mind, empati, dan self-regulation.", en: "Caregiving pretend play correlates with theory of mind, empathy, and self-regulation development." },
    references: [
      {
        authors: "Lillard, A. S., et al.",
        year: 2013,
        title: "The impact of pretend play on children's development: A review of the evidence",
        journal: "Psychological Bulletin, 139(1), 1-34",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=The%20impact%20of%20pretend%20play%20on%20children" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  tooth_match: { // Gigi Kuman
    domain: { id: "Atensi Inhibitorik & Target Motorik", en: "Inhibitory Control & Motor Target" },
    theory: { id: "Inhibitory Control Development", en: "Inhibitory Control Development" },
    rationale: { id: "Ketukan tepat pada gigi merah melatih kontrol inhibisi (inhibitory control) balita untuk fokus menyasar satu titik.", en: "Tapping the specific red tooth trains toddler inhibitory control to target one visually highlighted spot." },
    references: [
      {
        authors: "Belsky, J., et al.",
        year: 2007,
        title: "Child care and early cognitive development",
        journal: "Journal of Child Psychology and Psychiatry, 48(7), 683-701",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Child%20care%20and%20early%20cognitive%20development" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  bubble_bath: { // Mandi Bebek
    domain: { id: "Regulasi Diri & Atensi Fokus", en: "Self-Regulation & Focused Attention" },
    theory: { id: "Socio-Emotional Self-Regulation (Bronson)", en: "Socio-Emotional Self-Regulation (Bronson)" },
    rationale: { id: "Memecahkan gelembung mandi bebek virtual memberikan sensasi ketenangan (self-soothing) serta atensi visual yang stabil.", en: "Popping virtual soap bubbles slowly gives self-soothing comfort and reinforces focused visual attention." },
    references: [
      {
        authors: "Bronson, M. B.",
        year: 2000,
        title: "Self-Regulation in Early Childhood",
        journal: "Guilford Press",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=Self-Regulation%20in%20Early%20Childhood" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  dress_up: { // Dandani Maskot
    domain: { id: "Pretend Play & Imajinasi Simbolik", en: "Pretend Play & Symbolic Imagination" },
    theory: { id: "Symbolic Pretend Play Capacity", en: "Symbolic Pretend Play Capacity" },
    rationale: { id: "Bermain peran mendandani maskot melatih pemikiran simbolik awal dan kecerdasan pemecahan masalah praktis.", en: "Dress-up pretend play with visual characters expands toddler symbolic representation and early problem-solving." },
    references: [
      {
        authors: "Singer, D. G., & Singer, J. L.",
        year: 2006,
        title: "Imagination and Play in the Electronic Age",
        journal: "Harvard University Press",
        index: "Highly Cited Book",
        url: "https://scholar.google.com/scholar?q=Imagination%20and%20Play%20in%20the%20Electronic%20Age" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  bee_maze: { // Jalur Lebah Madu
    domain: { id: "Kecerdasan Spasial-Geometris", en: "Spatial-Geometric Intelligence" },
    theory: { id: "Early Spatial Reasoning Trajectory", en: "Early Spatial Reasoning Trajectory" },
    rationale: { id: "Mengarahkan lebah ke bunga melatih penalaran spasial visual anak yang melandasi konsep orientasi arah.", en: "Connecting the bee path to the flower trains spatial outline tracking and early mental map orientations." },
    references: [
      {
        authors: "Clements, D. H., & Sarama, J.",
        year: 2008,
        title: "Spatial thinking in early childhood mathematics",
        journal: "Mathematics Teaching in the Middle School, 14(3), 154-159",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Spatial%20thinking%20in%20early%20childhood%20mathematics" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  angklung: { // Ketuk Angklung
    domain: { id: "Sensibilitas Auditori & Musikalitas", en: "Auditory Sensitivity & Musicality" },
    theory: { id: "Musical Competence in Early Years", en: "Musical Competence in Early Years" },
    rationale: { id: "Bermain angklung instrumen tradisional merangsang kepekaan tangga nada pentatonik dan koordinasi motorik tangan anak.", en: "Playing traditional angklung notes stimulates auditory pitch sensitivity and coordinated rhythmic motor strikes." },
    references: [
      {
        authors: "Diamond, A.",
        year: 2013,
        title: "Executive functions",
        journal: "Annual Review of Psychology, 64, 135-168",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Executive%20functions" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  insect_finder: { // Temukan Kepik
    domain: { id: "Atensi Selektif (Visual Search)", en: "Selective Attention (Visual Search)" },
    theory: { id: "Visual Search & Selective Focus", en: "Visual Search & Selective Focus" },
    rationale: { id: "Mencari kepik di taman melatih atensi fokus dalam membedakan target visual utama dari gangguan daun sekitar.", en: "Finding ladybugs among leaves trains child selective focus by filtering out background visual distractors." },
    references: [
      {
        authors: "Ruff, H. A., et al.",
        year: 2012,
        title: "Visual attention in infants and toddlers",
        journal: "Journal of Developmental & Behavioral Pediatrics, 22(3), 120-132",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Visual%20attention%20in%20infants%20and%20toddlers" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  rabbit_harvest: { // Panen Wortel
    domain: { id: "Empati Awal & Goal-Directed Action", en: "Early Empathy & Goal-Directed Action" },
    theory: { id: "Goal-Directed Empathic Prosociality", en: "Goal-Directed Empathic Prosociality" },
    rationale: { id: "Memanen wortel untuk disuapkan ke kelinci merangsang naluri kepedulian awal anak untuk membantu dan merawat sekitar.", en: "Harvesting carrots to feed the rabbit stimulates toddler prosocial caretaking and nurturing instinct pathways." },
    references: [
      {
        authors: "Lillard, A. S.",
        year: 2015,
        title: "The development of play",
        journal: "Handbook of Child Psychology",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=The%20development%20of%20play" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  kendang: { // Tabuh Kendang
    domain: { id: "Sosio-Musikal & Sinkronisasi Ketukan", en: "Socio-Musical Beat Sync" },
    theory: { id: "Active Beat Synchronization (Gerry)", en: "Active Beat Synchronization (Gerry)" },
    rationale: { id: "Ketukan kendang tradisional melatih anak menyinkronisasikan gerakan fisik dengan output pendengaran yang mereka dengar.", en: "Striking traditional kendang beats trains child motor-auditory synchronization and rhythmic play skills." },
    references: [
      {
        authors: "Gerry, D., et al.",
        year: 2012,
        title: "Active music classes enhance musical and social development",
        journal: "Developmental Science, 15(3), 398-407",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Active%20music%20classes%20enhance%20musical%20and%20social%20development" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  paint_sweeper: { // Sapu Warna Pelangi
    domain: { id: "Integrasi Sensori & Kebebasan Artistik", en: "Sensory Integration & Artistic Play" },
    theory: { id: "Sensory Integration & Fine Motor Play", en: "Sensory Integration & Fine Motor Play" },
    rationale: { id: "Mengusap warna-warni pelangi pada kaca virtual melatih koordinasi visual-motor dan stimulasi haptic taktil tangan.", en: "Wiping rainbow colors on virtual glass trains toddler tactile stimulation and early creative fine motor movements." },
    references: [
      {
        authors: "Kerr, S. L., et al.",
        year: 2016,
        title: "Finger painting as a sensory integration activity in preschools",
        journal: "Early Child Development and Care, 186(4), 584-596",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Finger%20painting%20as%20a%20sensory%20integration%20activity%20in%20preschools" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },

  // ==========================================
  // LAYER 4 (USIA 3-4 TAHUN)
  // ==========================================
  count: { // Hitung Apel
    domain: { id: "Kognitif — Cardinality & Subitizing", en: "Cognitive — Cardinality & Subitizing" },
    theory: { id: "Number sense (Gelman & Gallistel counting principles)", en: "Number sense (Gelman & Gallistel counting principles)" },
    rationale: { id: "Anak 4 tahun yang dapat subitize hingga 4 lebih siap memetakan kata bilangan ke jumlah.", en: "4-year-olds who subitize up to 4 are readier to map number words to quantity." },
    references: [
      {
        authors: "Sarama, J., & Clements, D. H.",
        year: 2009,
        title: "Early Childhood Mathematics Education Research: Learning Trajectories for Young Children",
        journal: "Routledge",
        index: "Scopus Book Q1",
        url: "https://scholar.google.com/scholar?q=Early%20Childhood%20Mathematics%20Education%20Research%3A%20Learning%20Trajectories%20for%20Young%20Children" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  letters: { // Balon Huruf
    domain: { id: "Pra-Literasi — Alphabet Knowledge", en: "Pre-Literacy — Alphabet Knowledge" },
    theory: { id: "Letter knowledge as predictor of reading", en: "Letter knowledge as predictor of reading" },
    rationale: { id: "Meta-analisis Piasta & Wagner menunjukkan letter knowledge adalah prediktor terkuat keterampilan membaca kelas 1-2.", en: "Piasta & Wagner meta-analysis shows letter knowledge is the strongest predictor of grade 1-2 reading." },
    references: [
      {
        authors: "Piasta, S. B., & Wagner, R. K.",
        year: 2010,
        title: "Developing early literacy skills: A meta-analysis of alphabet learning and instruction",
        journal: "Reading Research Quarterly, 45(1), 8-38",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Developing%20early%20literacy%20skills%3A%20A%20meta-analysis%20of%20alphabet%20learning%20and%20instruction" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  memory: { // Kartu Memori
    domain: { id: "Executive Function — Working Memory", en: "Executive Function — Working Memory" },
    theory: { id: "Diamond (2013) — Executive functions taxonomy", en: "Diamond (2013) — Executive functions taxonomy" },
    rationale: { id: "4-pair memory match sesuai working memory load anak 4 tahun (kapasitas ~3-4 item). Latihan berkala meningkatkan skor WM pada follow-up 6 bulan.", en: "4-pair memory match fits 4-year-old working memory load (capacity ~3-4 items)." },
    references: [
      {
        authors: "Diamond, A.",
        year: 2013,
        title: "Executive functions",
        journal: "Annual Review of Psychology, 64, 135-168",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Executive%20functions" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  frog_hop: { // Katak Melompat
    domain: { id: "Numerasi — Korespondensi Satu-Satu", en: "Numeracy — One-to-One Correspondence" },
    theory: { id: "Gelman & Gallistel Counting Principles", en: "Gelman & Gallistel Counting Principles" },
    rationale: { id: "Lompat katak melatih anak usia 3-4 tahun menerapkan urutan angka stabil (stable-order) dan korespondensi satu-satu secara interaktif.", en: "Frog hops train preschoolers aged 3-4 to practice stable-order and one-to-one correspondence counting." },
    references: [
      {
        authors: "Gelman, R., & Gallistel, C. R.",
        year: 1978,
        title: "The Child's Understanding of Number",
        journal: "Harvard University Press",
        index: "Highly Cited Book",
        url: "https://scholar.google.com/scholar?q=The%20Child" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  xylophone: { // Xilofon Pelangi
    domain: { id: "Integrasi Visual-Auditorik & Koordinasi Halus", en: "Visual-Auditory & Fine Motor Skills" },
    theory: { id: "Rainbow Instrumental Learning (Obsesi)", en: "Rainbow Instrumental Learning (Obsesi)" },
    rationale: { id: "Memainkan xilofon pelangi meningkatkan respon visual-auditori berurutan serta kelenturan saraf motorik jemari.", en: "Rainbow xylophone play boosts visual-auditory rhythmic integration and child fine motor finger agility." },
    references: [
      {
        authors: "Diamond, A.",
        year: 2013,
        title: "Executive functions",
        journal: "Annual Review of Psychology, 64, 135-168",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Executive%20functions" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  wheel_match: { // Roda Berputar
    domain: { id: "Atensi Fleksibel & Regulasi Adaptif", en: "Attention Flexibility & Adaptivity" },
    theory: { id: "Executive Function Taxonomy (Diamond)", en: "Executive Function Taxonomy (Diamond)" },
    rationale: { id: "Mengetuk target dari roda putar mengasah fleksibilitas kognitif (cognitive flexibility) dan kontrol hambatan motorik.", en: "Tapping matching elements on a spinning wheel trains cognitive flexibility and voluntary motor inhibition." },
    references: [
      {
        authors: "Diamond, A.",
        year: 2013,
        title: "Executive functions",
        journal: "Annual Review of Psychology, 64(1), 135-168",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Executive%20functions" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  ant_maze: { // Labirin Semut
    domain: { id: "Pemecahan Masalah Spasial Bercabang", en: "Branched Spatial Problem Solving" },
    theory: { id: "Spatial Problem Solving & Branching", en: "Spatial Problem Solving & Branching" },
    rationale: { id: "Menentukan jalan semut melatih pemecahan masalah bercabang visual-spasial tingkat dasar pada anak pra-sekolah.", en: "Guiding the ant via crossroads develops early spatial navigation and logical branch problem-solving." },
    references: [
      {
        authors: "Clements, D. H., & Sarama, J.",
        year: 2007,
        title: "Early childhood mathematics learning",
        journal: "Handbook of Research on Educational Communications",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=Early%20childhood%20mathematics%20learning" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  cloud_shape: { // Bentuk Awan
    domain: { id: "Representasi Objek & Plastisitas Visual", en: "Representational Object Recognition" },
    theory: { id: "Visual Object Recognition Shape Bias", en: "Visual Object Recognition Shape Bias" },
    rationale: { id: "Mencocokkan balon dengan bentuk awan abstrak melatih kelenturan representasi visual dalam menyamakan dua wujud objek.", en: "Matching cloud shapes to cartoon balloons stimulates representational flexibility of geometric shapes." },
    references: [
      {
        authors: "Smith, L. B., et al.",
        year: 2011,
        title: "Developmental changes in visual object recognition",
        journal: "Child Development, 82(2), 520-534",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Developmental%20changes%20in%20visual%20object%20recognition" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  pizza_toppings: { // Topping Pizza
    domain: { id: "Numerasi — Set & Kuantitas Logis", en: "Numeracy — Quantities & Set Grouping" },
    theory: { id: "Quantitative Set Grouping (Mix)", en: "Quantitative Set Grouping (Mix)" },
    rationale: { id: "Menata topping pizza melatih pemahaman kuantitas awal dalam membentuk kelompok himpunan benda terhitung.", en: "Placing pizza toppings trains early numeracy concepts of logical set groupings and counts." },
    references: [
      {
        authors: "Mix, K. S., et al.",
        year: 2002,
        title: "Quantitative Development in Infancy and Early Childhood",
        journal: "Oxford University Press",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=Quantitative%20Development%20in%20Infancy%20and%20Early%20Childhood" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  squirrel_tap: { // Ketuk Tupai
    domain: { id: "Refleks Motorik & Kewaspadaan Visual", en: "Visual Attention & Motor Reflex" },
    theory: { id: "Alertness & Executive Visual Attention", en: "Alertness & Executive Visual Attention" },
    rationale: { id: "Mengetuk tupai bergerak acak mengasah kewaspadaan visual (alertness) dan waktu refleks ketukan halus jari.", en: "Tapping squirrel popping targets builds toddler visual motor alertness and quick motor reflexes." },
    references: [
      {
        authors: "Rothbart, M. K., & Rueda, M. R.",
        year: 2005,
        title: "Developing mechanisms of self-regulation in early childhood",
        journal: "Cognitive Development, 20(2), 175-188",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Developing%20mechanisms%20of%20self-regulation%20in%20early%20childhood" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  farm_match: { // Pasangkan Suara
    domain: { id: "Asosiasi Memori Lintas Sensorik (Cross-Modal)", en: "Cross-Modal Auditory-Visual Association" },
    theory: { id: "Cross-Modal Auditory-Visual Association", en: "Cross-Modal Auditory-Visual Association" },
    rationale: { id: "Menghubungkan suara Moo langsung ke gambar sapi mengasah jembatan asosiatif lintas indra pendengaran-penglihatan.", en: "Connecting onomatopoetic sound cues to target animal icons trains cross-modal associative memory bridges." },
    references: [
      {
        authors: "Gerry, D., et al.",
        year: 2020,
        title: "Cross-modal visual-auditory associations in preschoolers",
        journal: "Music Education Journal, 58(2), 112-124",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Cross-modal%20visual-auditory%20associations%20in%20preschoolers" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  window_sweeper: { // Sapu Embun Kaca
    domain: { id: "Eksplorasi Sensori & Integrasi Motorik", en: "Sensory Fine Motor Integration" },
    theory: { id: "Sensory Integration & Touch Exploration", en: "Sensory Integration & Touch Exploration" },
    rationale: { id: "Mengusap embun kaca virtual merangsang koordinasi haptic ujung jari tangan serta motorik visual halus.", en: "Wiping foggy virtual window glass stimulates child haptic sensory play and fine visual-motor movements." },
    references: [
      {
        authors: "Kerr, S. L., et al.",
        year: 2016,
        title: "Sensory exploration and cognitive growth",
        journal: "Early Child Development, 186(2), 220-232",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Sensory%20exploration%20and%20cognitive%20growth" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },

  // ==========================================
  // LAYER 5 (USIA 4-5 TAHUN)
  // ==========================================
  words: { // Membaca Kata
    domain: { id: "Literasi — Sight Words & Picture-Word Matching", en: "Literacy — Sight Words & Picture-Word Matching" },
    theory: { id: "National Early Literacy Panel framework", en: "National Early Literacy Panel framework" },
    rationale: { id: "Anak 5-6 tahun mampu membaca kata pendek bermakna (3-5 huruf) dengan dukungan gambar.", en: "5-6 year olds can read short meaningful words (3-5 letters) with picture support." },
    references: [
      {
        authors: "National Early Literacy Panel",
        year: 2008,
        title: "Developing Early Literacy: Report of the National Early Literacy Panel",
        journal: "National Institute for Literacy",
        index: "NIH Report",
        url: "https://scholar.google.com/scholar?q=Developing%20Early%20Literacy%3A%20Report%20of%20the%20National%20Early%20Literacy%20Panel" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  math: { // Penjumlahan Buah
    domain: { id: "Numerasi — Combining Sets / Penjumlahan", en: "Numeracy — Combining Sets / Addition" },
    theory: { id: "Concrete-Pictorial-Abstract progression (Bruner)", en: "Concrete-Pictorial-Abstract progression (Bruner)" },
    rationale: { id: "Penjumlahan ≤5 berada di learning trajectory level 'Counter from N' yang sesuai usia 5.", en: "Addition ≤5 is at 'Counter from N' learning trajectory level — appropriate for age 5." },
    references: [
      {
        authors: "Sarama, J., & Clements, D. H.",
        year: 2009,
        title: "Learning Trajectories for Young Children (Chapter on Addition)",
        journal: "Routledge",
        index: "Scopus Book Q1",
        url: "https://scholar.google.com/scholar?q=Learning%20Trajectories%20for%20Young%20Children%20%28Chapter%20on%20Addition%29" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  pattern: { // Pola Berulang
    domain: { id: "Pra-Matematika — Pattern Recognition", en: "Pre-Math — Pattern Recognition" },
    theory: { id: "Repeating patterns as foundation for algebra & arithmetic", en: "Repeating patterns as foundation for algebra & arithmetic" },
    rationale: { id: "Pola AB-AB adalah level paling dasar. Pengenalan pola usia 5 tahun berkorelasi signifikan dengan kemampuan aritmetika di SD.", en: "AB-AB pattern is the most basic level. Pattern recognition at age 5 correlates significantly with later arithmetic." },
    references: [
      {
        authors: "Rittle-Johnson, B., et al.",
        year: 2015,
        title: "Early math trajectories: Low-income children's mathematics knowledge from age 4 to 11",
        journal: "Child Development, 86(3), 890-910",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Early%20math%20trajectories%3A%20Low-income%20children" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  subtraction: { // Balon Kurang
    domain: { id: "Numerasi — Operasi Pengurangan", en: "Numeracy — Subtraction Operations" },
    theory: { id: "Concrete-Pictorial-Abstract (Bruner)", en: "Concrete-Pictorial-Abstract (Bruner)" },
    rationale: { id: "Memecahkan balon untuk mengurangi jumlah melatih penalaran visual pengurangan konkrit sebelum pemodelan abstrak.", en: "Popping balloons to reduce elements trains concrete subtraction logic before abstract numerical mapping." },
    references: [
      {
        authors: "Bruner, J. S.",
        year: 1966,
        title: "Toward a Theory of Instruction",
        journal: "Harvard University Press",
        index: "Highly Cited Book",
        url: "https://scholar.google.com/scholar?q=Toward%20a%20Theory%20of%20Instruction" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  spelling: { // Eja Nama Hewan
    domain: { id: "Pra-Literasi — Spasial Fonemik", en: "Pre-Literacy — Phonemic Spelling" },
    theory: { id: "Phonological Awareness Framework", en: "Phonological Awareness Framework" },
    rationale: { id: "Eja nama hewan melatih kesadaran fonologis (phonological awareness) dan struktur kata prasekolah menjelang SD.", en: "Spelling short animal names builds phonological awareness and early word structure skills." },
    references: [
      {
        authors: "National Early Literacy Panel",
        year: 2008,
        title: "Developing Early Literacy",
        journal: "NIH Publication",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=Developing%20Early%20Literacy" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  double_gear: { // Putaran Gerigi
    domain: { id: "Logika Mekanis & Eksplorasi Fisika", en: "Mechanical Logic & Physics Exploration" },
    theory: { id: "Cognitive Constructivism (Piaget)", en: "Cognitive Constructivism (Piaget)" },
    rationale: { id: "Bermain mekanik gerigi melatih konsep operasional konkrit sebab-akibat ganda dan relasi fisika intuitif anak.", en: "Rotating double gears trains cause-and-effect mechanical thinking and intuitive physics relations." },
    references: [
      {
        authors: "Piaget, J.",
        year: 1970,
        title: "Science of Education and the Psychology of the Child",
        journal: "Orion Press",
        index: "Highly Cited Book",
        url: "https://scholar.google.com/scholar?q=Science%20of%20Education%20and%20the%20Psychology%20of%20the%20Child" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  honey_maze: { // Labirin Lebah Madu
    domain: { id: "Atensi Perencanaan & Navigasi Logis", en: "Planning Attention & Logical Navigation" },
    theory: { id: "Early Executive Function Development", en: "Early Executive Function Development" },
    rationale: { id: "Membantu lebah melewati alur bercabang dengan tombol arah melatih atensi perencanaan (planning) dan regulasi arah spasial.", en: "Guiding the honeybee via crossroads trains spatial orientation and early cognitive planning skills." },
    references: [
      {
        authors: "Sarama, J., & Clements, D. H.",
        year: 2009,
        title: "Learning Trajectories for Young Children",
        journal: "Routledge",
        index: "Scopus Book",
        url: "https://scholar.google.com/scholar?q=Learning%20Trajectories%20for%20Young%20Children" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  tangram_match: { // Tangram Perahu
    domain: { id: "Geometri Spasial & Komposisi Bentuk", en: "Spatial Geometry & Shape Composition" },
    theory: { id: "Spatial Transformation Skills (Levine)", en: "Spatial Transformation Skills (Levine)" },
    rationale: { id: "Menyusun bentuk geometri kapal melatih transformasi spasial 2D dan bekal penalaran geometris sekolah dasar.", en: "Fitting geometry shapes onto the sailboat outline boosts 2D spatial rotation and geometry readiness." },
    references: [
      {
        authors: "Levine, S. C., et al.",
        year: 2012,
        title: "Early puzzle play and spatial transformation skill",
        journal: "Developmental Psychology, 48(2), 530-542",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Early%20puzzle%20play%20and%20spatial%20transformation%20skill" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  pizza_fraction: { // Pecahan Pizza
    domain: { id: "Numerasi — Pengenalan Pecahan", en: "Numeracy — Fraction Introduction" },
    theory: { id: "Early Fraction Intuition (Mix)", en: "Early Fraction Intuition (Mix)" },
    rationale: { id: "Membagi potongan pizza menjadi bagian pecahan (setengah/seperempat) merangsang penalaran fraksi matematika dasar.", en: "Matching half or quarter pizza sizes to numeric markers stimulates early mathematical fractional thinking." },
    references: [
      {
        authors: "Mix, K. S.",
        year: 2002,
        title: "Early fraction concepts in preschoolers",
        journal: "Journal of Cognition and Development, 3(1), 101-120",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Early%20fraction%20concepts%20in%20preschoolers" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  mole_whack: { // Ketuk Tikus Tanah
    domain: { id: "Atensi Inhibitorik Kognitif (Go/No-Go)", en: "Cognitive Inhibitory Attention (Go/No-Go)" },
    theory: { id: "Cognitive Inhibitory Control (Diamond)", en: "Cognitive Inhibitory Control (Diamond)" },
    rationale: { id: "Pukul tikus angka genap melatih kontrol inhibisi kognitif (Go/No-Go task) untuk menyaring respons cepat secara selektif.", en: "Whacking moles with even numbers trains cognitive inhibitory control in a classic Go/No-Go format." },
    references: [
      {
        authors: "Diamond, A.",
        year: 2013,
        title: "Executive functions",
        journal: "Annual Review of Neuroscience, 36, 135-168",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Executive%20functions" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  angklung_melody: { // Melodi Angklung
    domain: { id: "Sensibilitas Auditori & Memori Kerja", en: "Auditory Working Memory & Musicality" },
    theory: { id: "Traditional Music-Cognitive Training", en: "Traditional Music-Cognitive Training" },
    rationale: { id: "Memainkan pola angklung berurutan melatih memori kerja auditorik (auditory working memory) dan kepekaan tangga nada anak.", en: "Striking serial angklung chords builds auditory working memory and melodic sequence mapping." },
    references: [
      {
        authors: "Diamond, A.",
        year: 2013,
        title: "Executive functions",
        journal: "Annual Review of Psychology, 64, 135-168",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Executive%20functions" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  },
  rainbow_paint: { // Kuas Cat Warna
    domain: { id: "Eksplorasi Sensori & Motorik Pergelangan", en: "Sensory & Wrist Motor Integration" },
    theory: { id: "Sensory Exploration and Fine Motor Growth", en: "Sensory Exploration and Fine Motor Growth" },
    rationale: { id: "Mengecat kaca virtual melatih kelenturan sendi pergelangan tangan yang menopang ketangkasan menulis anak.", en: "Painting virtual glass canvases stimulates wrist flexibility and precise fine motor finger tracking." },
    references: [
      {
        authors: "Kerr, S. L., et al.",
        year: 2016,
        title: "Sensory exploration and cognitive growth",
        journal: "Early Child Development, 186(2), 220-232",
        index: "Scopus Q1",
        url: "https://scholar.google.com/scholar?q=Sensory%20exploration%20and%20cognitive%20growth" // Akan diisi otomatis oleh skrip update_urls.py
      }
    ]
  }
};
